// import axios from 'axios';
import { error } from "jquery";
import { axiosInstance, chartInstance, devConfig } from "../baseApi";
export async function getScoreChartData(symbol, count) {
  // console.log("count", count);
  try {
    const res = await axiosInstance.get("score", {
      params: {
        symbol: `${symbol}USDT`,
        ob_number: count,
      },
    });
    // console.log('data',res.data);
    let result = res.data;
    if (result.status == "fail") {
      return { status: result.status };
    } else {
      let priceArray = [];
      let scoreArray = [];
      Object.keys(result).forEach((key) => {
        // "info" 키를 제외한 데이터 항목 처리
        if (key !== "info") {
          let entry = result[key];
          let timestamp = new Date(entry.date).getTime(); // date 값을 timestamp로 변환
          let price = parseFloat(entry.price); // price 값을 숫자로 변환
          let score = parseFloat(entry.score); // score 값을 숫자로 변환

          // 배열에 데이터 포인트 추가
          priceArray.push({ x: timestamp, y: price });
          scoreArray.push({ x: timestamp, y: score });
        }
      });
      return { status: "success", priceArray, scoreArray };
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}
// let scoreUrl = 'https://chart-api.risingx.io';

export async function getScoreListData() {
  try {
    const res = await chartInstance.get(`/analysis/score`);
    // console.log('data',res.data);
    let result = res.data.result;
    // console.log('result',result);
    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getScoreSignalData() {
  try {
    const res = await chartInstance.get(`/analysis/current-signal`);
    let result = res.data.result;
    let fixed_signal;
    result.forEach((list) => {
      // console.log('list time',list.datetime);
      // console.log('getHours(list.datetime)',getHours(Number(list.datetime)),'getCurrentHours()',getCurrentHours());
      if (getHours(Number(list.datetime)) === getCurrentHours()) {
        if (list.signal == "L") {
          fixed_signal = "S";
        } else if (list.signal == "S") {
          fixed_signal = "L";
        }
      } else {
        fixed_signal = list.signal;
      }
      list.ticker = list.ticker + "USDT";
      list.fixed_signal = fixed_signal;
    });
    // console.log('result',result);
    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getPreviousSignal() {
  try {
    const res = await chartInstance.get("/analysis/confirmed-signal");
    let result = res.data.result;

    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getChangedSignal() {
  try {
    const res = await chartInstance.get("/analysis/now-signal");
    let result = res.data.result;

    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getPriceLocation() {
  try {
    const res = await chartInstance.get("/analysis/goya-line");
    let result = res.data.result;

    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getTrendLine() {
  try {
    const res = await chartInstance.get("/analysis/trend-line");
    let result = res.data.result;

    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}
export async function getScoreMore() {
  try {
    const res = await chartInstance.get(`/analysis/score/more`);
    let result = res.data.result;
    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}
function getHours(time) {
  const date = new Date(time * 1000);
  const hours = String(date.getHours()).padStart(2, "0");
  // const minutes = String(date.getMinutes()).padStart(2, '0');
  // const seconds = String(date.getSeconds()).padStart(2, '0');
  // console.log('hours',hours);

  return `${hours}`;
}

function getCurrentHours() {
  const date = new Date();
  const hours = String(date.getHours()).padStart(2, "0");
  // const minutes = String(date.getMinutes()).padStart(2, '0');
  // const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${hours}`;
}

export function displayDate(time) {
  const date = new Date(time * 1000);
  // 년, 월, 일 추출
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth()는 0부터 시작하므로 +1
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  // const seconds = String(date.getSeconds()).padStart(2, '0');
  // console.log('hours',hours);

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export const getAlphaSignal = async () => {
  try {
    const response = await fetch(`${devConfig.baseUrl}/analysis/now-signal`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching trend line:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getGdSignal = async () => {
  try {
    const response = await fetch(`${devConfig.baseUrl}/analysis/gd-signal`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching trend line:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getStrategySignal = async (strategy) => {
  try {
    const response = await chartInstance.get(
      `/strategy/coin-list?strategy=${strategy}`
    );

    let result = response.data.result;

    return result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};
